import { createRouteFor } from '@components-common/routes';
export const sectionBase = "building_configurations";
export const routeId = ":buildingConfigurationId";
export const routeIdBase = `${sectionBase}`;

const routesForBuildingConfig = createRouteFor<typeof routeIdBase,"building_configurations">(routeIdBase,"building_configurations");

export const buildingConfigurationsRoutes = {
  index: routesForBuildingConfig("index",{basePath:""}),
  create: routesForBuildingConfig("create",{basePath:""}),
  details: routesForBuildingConfig("details",{basePath:""})
}

export type BuildingConfigurationsRoutesIds = typeof buildingConfigurationsRoutes[keyof typeof buildingConfigurationsRoutes]["id"];
